"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.preview.title': 'Bot Test Preview',
    'botTest.preview.run': 'Run Test',
    'botTest.preview.edit': 'Edit Test',
    'botTest.preview.back': 'Back to List',
    'botTest.preview.section.basic_info': 'Basic Information',
    'botTest.preview.section.statistics': 'Statistics',
    'botTest.preview.section.testers': 'Test Configuration',
    'botTest.preview.not_provided': 'Not provided',
    'botTest.preview.total_testers': 'Total Testers',
    'botTest.preview.total_targets': 'Total Targets',
    'botTest.preview.creator': 'Created By',
    'botTest.preview.unknown_creator': 'Unknown',
    'botTest.preview.testers_count': 'Testers',
    'botTest.preview.targets_count': 'Targets',
    'botTest.preview.created_date': 'Created',
    'botTest.preview.updated_date': 'Last Updated',
    'botTest.preview.tester_configuration': 'Tester Configuration',
    'botTest.preview.prompt_overridden': 'Prompt Overridden',
    'botTest.preview.no_targets': 'No targets configured',
    'botTest.preview.unknown_avatar': 'Unknown Avatar',
    'botTest.preview.no_testers': 'No Testers Configured',
    'botTest.preview.no_testers_description': 'Add testers to configure the AI models and prompts for testing.',
    'botTest.preview.not_found': 'Bot Test Not Found',
    'botTest.preview.not_found_description': 'The requested bot test could not be found or has been deleted.',
    'botTest.preview.no_model': 'No model',
    'botTest.preview.unknown_model': 'Unknown model',
    'botTest.preview.status.unknown': 'Unknown',
    'botTest.preview.status.active': 'Active',
    'botTest.preview.status.inactive': 'Inactive',
    'botTest.preview.status.standby': 'Standby',
    'botTest.preview.status.pending': 'Pending',
    'botTest.preview.status.running': 'Running',
    'botTest.preview.status.completed': 'Completed',
    'botTest.preview.status.failed': 'Failed',
    'botTest.preview.error.load_failed': 'Failed to load bot test',
    'botTest.preview.run_confirmation': 'Are you sure you want to run this test?',
    'botTest.preview.run_started': 'Bot test started successfully',
    'botTest.preview.run_failed': 'Failed to start bot test',
    'botTest.preview.tabs.data': 'Data',
    'botTest.preview.tabs.test_results': 'Test Results',
    'botTest.preview.section.test_results': 'Test Results',
    'botTest.preview.no_test_results': 'No Test Results Available',
    'botTest.preview.no_test_results_description': 'Run the bot test to see results here.',
    'botTest.preview.model': 'Model',
    'botTest.preview.temperature': 'Temperature',
    'botTest.preview.completed': 'Completed',
    'botTest.preview.failed': 'Failed',
    'botTest.preview.status': 'Status',
    'botTest.preview.messages': 'Messages',
    'botTest.preview.tokens': 'Tokens',
    'botTest.preview.duration': 'Duration',
    'botTest.preview.total_messages': 'Total Messages',
    'botTest.preview.total_tokens': 'Total Tokens',
    'botTest.preview.avg_duration': 'Avg Duration',
};
